import rentalAnalysisTool from '@/assets/images/portfolio/RentalAnalysisTool.gif'
import herokuapp from '@/assets/images/portfolio/herokuapp.png'
import scrapper from '@/assets/images/portfolio/scrapper.jpg'
import warehosuse from '@/assets/images/portfolio/warehouse.png'
import stock from '@/assets/images/portfolio/stock.jpg'
import gmclone from '@/assets/images/portfolio/gmclone.png'
import Post from './Post'

const Posts = () => {
  const posts = [
    {
      title: 'Go Chat Application',
      subtitle: 'Real-time Chat with Channels and Rooms',
      imageUrl: gmclone,
      description:
        'A real-time chat application built with Go and PostgreSQL. Features user registration, channel creation, room-based messaging, and real-time communication. Backend uses Gorilla/mux for routing and JWT for authentication. Frontend built with React, SCSS, and JavaScript. Supports Docker deployment with environment-based configuration.',
      codeLink: 'https://github.com/luisVargasGu/go-server',
    },
    {
      title: 'Project 2',
      subtitle: 'Kijiji Webscrapper',
      imageUrl: scrapper,
      description:
        'This is a short demo on webscrapping, multithreading, and some google APIs using kijiji as the website of choice. ',
      codeLink: 'https://github.com/luisVargasGu/WebScrapper',
    },
    {
      title: 'Project 3',
      subtitle: 'Data Analysis and PDF generator app',
      imageUrl: rentalAnalysisTool,
      description:
        'Utilized the dataset that was generated with the previously built webscrapper and created a GUI that would allow me to interact with data.',
    },
    {
      title: 'Project 4',
      subtitle: 'Backend Node File manager',
      imageUrl: herokuapp,
      description:
        'Utilized server side node, and javascript to make a File manager. In broswer pdf viewing, and chunk playback functionality. Deployed with Heroku.',
    },
    {
      title: 'Project 5',
      subtitle: 'Warehousing company',
      imageUrl: warehosuse,
      description:
        'Indepth and complete warehouse operations managemer with docTests',
      codeLink: 'https://github.com/luisVargasGu/warehouse',
    },
    {
      title: 'Stock Portfolio Tracker',
      subtitle: 'Microservices-Based Investment Portfolio Management',
      imageUrl: stock,
      description:
        'A comprehensive application for managing and monitoring investment portfolios. Built with Go microservices architecture, featuring user management, portfolio tracking, real-time market data integration, notifications, and analytics dashboard. Includes CI/CD pipeline with GitHub Actions, Docker containerization, and Kubernetes orchestration. Uses PostgreSQL for data persistence and Redis for caching.',
      codeLink: 'https://github.com/luisVargasGu/stockTracker',
    },
  ]

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
      {posts.map((post, index) => (
        <Post key={index} {...post} />
      ))}
    </section>
  )
}

export default Posts
